import React, { createContext, useMemo } from "react";

import { useAuth } from "../context/AuthContext";
import config from "../lib/config";
import { getStoredAuthToken } from "../lib/authStorage";
import SportsService from "../_services/sports.services";
import SportsnewService from "../_services/sportsnew.services";
import SportsbookHistoryService from "../_services/sportsbookHistory.services";
import GamesService from "../_services/games.services";

export const ServiceContext = createContext(null);

export const ServiceContextProvider = ({ children }) => {
  const { user, signOut } = useAuth();
  const token = getStoredAuthToken();

  const services = useMemo(() => {
    const options = {
      token,
      baseURL: config.api.baseUrl,
      timeout: 50000,
      lang: "ko",
      logout: signOut,
    };

    return {
      SportsService: new SportsService(options),
      SportsnewService: new SportsnewService(options),
      SportsbookHistoryService: new SportsbookHistoryService(options),
      GamesService: new GamesService(options),
    };
  }, [signOut, token]);

  const session = useMemo(() => {
    if (!user?.isAuthenticated) return { user: null };
    return {
      user: {
        ...(user.profile || {}),
        id: user.id || user.profile?.id || user.profile?.member_id,
        token,
      },
    };
  }, [token, user]);

  const value = useMemo(
    () => ({ services, session, lang: "ko" }),
    [services, session]
  );

  return <ServiceContext.Provider value={value}>{children}</ServiceContext.Provider>;
};
